import React from 'react';
import { Card } from "react-bootstrap";
import face_I_G_Kulcsar from "../../assets/img/face_Imre_Gabor_Kulcsar.png";
import ShowMoreText from "react-show-more-text";
import projKulcsarIG_digital from "../../assets/img/projKulcsarIG_digital.png";

const I_G_Kulcsar_digital = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={projKulcsarIG_digital} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_I_G_Kulcsar}
              /* this will be the text on the banner */
              alt="Digital transformation and business performance"
            />{" "}
            <p className="text7">Imre Gábor Kulcsár</p>
            <br />
            <p className="text8">
              PhD student{" "}
            </p>
            <p className="text8">Department of Management and Business Economics, BME</p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            Digital transformation of small or large enterprises is a challenge that many struggle to overcome. 
            In the world of businesses many factors influence whether the outcome of such transformation initiative 
            ends with success or failure. This research focuses on statistical approach to determine which digital 
            initiatives result in improved business performance. The task is to choose and conduct appropriate 
            statistical analysis such as clustering, ANOVA, cross tabulation on surveys and establish relationships 
            between digital transformation initiatives (like marketing digitalization, process digitalization, IT 
            security measures) or digital maturity measures and business performance indicators like profitability 
            and productivity. It gives an opportunity for the student to join industrial and international research 
            cooperations.         
            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default I_G_Kulcsar_digital;